import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import TermsOfUse from '@/components/TermsOfUse';
import PrivacyPolicy from '@/components/PrivacyPolicy';

const TermsAcceptanceDialog = ({ open, onAccept, onReject, isSubmitting }) => {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent
        className="max-w-5xl max-h-[90vh] overflow-hidden flex flex-col gap-4"
        onInteractOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={(event) => event.preventDefault()}
      >
        <DialogHeader className="text-left">
          <DialogTitle>Precisamos do seu aceite</DialogTitle>
          <DialogDescription className="text-white/70">
            Leia atentamente os Termos de Uso e a Política de Privacidade do sistema. O acesso só será liberado após o aceite.
          </DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto pr-2 space-y-6">
          <TermsOfUse />
          <PrivacyPolicy />
        </div>

        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-sm text-white/70">
            Ao aceitar, você confirma que leu e concorda com os Termos de Uso e a Política de Privacidade.
          </p>
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={onReject} disabled={isSubmitting}>
              Sair sem aceitar
            </Button>
            <Button onClick={onAccept} disabled={isSubmitting}>
              {isSubmitting ? 'Registrando aceite...' : 'Li e aceito'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TermsAcceptanceDialog;

